export default __webpack_public_path__ + "static/media/sm-planet.3d2a6522.png";